import WasmController from "react-lib/frameworks/WasmController";
import { State as MainState } from "react-lib/apps/segment/SegmentInterface";

import Scheduling from "issara-sdk/apis/Scheduling_apps_QUE";
// import DivisionProviderView from "issara-sdk/apis/DivisionProviderView_apps_QUE";
import { formatDateAD } from "react-lib/utils/dateUtils";
import PatientAppointmentView from "issara-sdk/apis/PatientAppointmentView_apps_QUE";
import OfficialAccountDivisionDetail from "issara-sdk/apis/OfficialAccountDivisionDetail_apps_PRXM";
import { formatDateTimeToISO } from "react-lib/utils/dateUtils";
import CONFIG from "config/config";
import PatientAppointmentUpdate from "issara-sdk/apis/PatientAppointmentUpdate_apps_QUE";
import AppointmentPackageList from "issara-sdk/apis/AppointmentPackageList_apps_APP";
import { getValidPackageSelection } from "react-lib/apps/HISV3/HCU/sequence/packageSelection";
import { isAppointmentTimeAvailable } from "../appointments/appointmentAvailability";

// import AppointmentDetail from "issara-sdk/apis/AppointmentDetail_apps_APP";

// import { Event as MEHInterface } from "../MEHInterface";

export type State = {
  MakeAppointmentMeHeySequence: {
    divisionProfile: any;
    allProviders: {
      code: string;
      first_name: string | null;
      last_name: string | null;
      pre_name: string | null;
      provider_id: number;
    }[];
    dsb: any;
    selectedProviderIdsList: number[];
    currentDate: Date;
    viewType: "month" | "week" | "day";
    dsbMonthStore: Set<string>;
    sequenceIndex?: string;
    showSuccess: boolean;
    showError: boolean;
    errorMessage: any;
    showCreateModal: boolean;
    AppointmentLoading: boolean;
    selectedAppointmentDetail?: any | null;
  };
};

export const StateInitial: State = {
  MakeAppointmentMeHeySequence: {
    sequenceIndex: "Start",
    divisionProfile: null,
    allProviders: [],
    selectedProviderIdsList: [],
    dsb: null,
    currentDate: new Date(),
    viewType: "month",
    dsbMonthStore: new Set<string>(),
    showSuccess: false,
    showError: false,
    errorMessage: null,
    showCreateModal: false,
    AppointmentLoading: false,
    selectedAppointmentDetail: null,
  },
};

export type Props = {};

export type Event =
  | { message: "RunSequence"; params: {} }
  | { message: "GetMasterData"; params: {} };

export type Data = {
  division?: number;
};

type Picked = Partial<
  Pick<MainState, "selectedDivision" | "errorMessage" | "successMessage" | "masterOptions">
>;

export const DataInitial = {};

type Handler<P = any, R = any> = (
  controller: WasmController<State & Picked, Event, Data, Props>,
  params: P,
) => R;

export const Start: Handler = async (controller, params) => {
  console.log("Start params: ", params);
  const division = controller.data.division;
  controller.setState({ MakeAppointmentMeHeySequence: { ...StateInitial.MakeAppointmentMeHeySequence } });
  let providerSearchResult: any = null;
  let dsbProviderFilterResult: any = null;

  let { start, end, store } = getDSBRange(new Date());

  try {
    const [result, combine] = await Promise.all([
      Scheduling.get({
        command: "ProviderSearch",
        apiToken: controller.apiToken,
        extra: {
          division: controller.data.division,
        },
        params: {
          division: controller.data.division,
        },
      }),
      Scheduling.get({
        command: "DivisionServiceBlockFilter",
        apiToken: controller.apiToken,
        extra: {
          division: controller.data.division,
        },
        params: {
          divisions: controller.data.division,
          start_date: start,
          end_date: end,
        },
      }),
    ]);

    [providerSearchResult] = result;
    [dsbProviderFilterResult] = combine;

    // dsbProviderFilterResult = dsbProviderFilterResult.reduce(
    //   (
    //     acc: Record<number, (typeof dsbProviderFilterResult)[0]>,
    //     item: (typeof dsbProviderFilterResult)[0]
    //   ) => {
    //     acc[item.dsb_id] = item;
    //     return acc;
    //   },
    //   {} as Record<number, (typeof dsbProviderFilterResult)[0]>
    // );
  } catch (error) {
    console.error("Error fetching division profile:", error);
  } finally {
    if (controller.data.division === division) controller.setState(
      (prevState) => {
        console.log(
          "prevState.MakeAppointmentMeHeySequence: ",
          prevState.MakeAppointmentMeHeySequence,
        );
        return {
          MakeAppointmentMeHeySequence: {
            ...StateInitial.MakeAppointmentMeHeySequence,
            sequenceIndex: "Action",
            ...(providerSearchResult && { allProviders: providerSearchResult }),
            ...(dsbProviderFilterResult && { dsb: sortDSB(dsbProviderFilterResult) }),
            ...(store && { dsbMonthStore: store }),
          },
        };
      },
      () => {
        controller.handleEvent({
          message: "RunSequence",
          params: {
            sequence: "MakeAppointmentMeHey",
            action: "BATCH_DL",
            currentDate: new Date(),
          },
        });
      },
    );
  }
};

export const Action: Handler = async (controller, params) => {
  switch (params.action) {
    case "SET_PROVIDER_FILTER":
      return SetProviderFilters(controller, params);
    case "SET_CURRENT_DATE":
      return SetCurrentDate(controller, params);
    case "SET_VIEW_TYPE":
      return SetViewType(controller, params);
    case "SET_SHOW_CREATE_MODAL":
      return SetShowCreateModal(controller, params);
    case "SET_SHOW_EDIT_MODAL":
      return SetShowEditModal(controller, params);
    case "BATCH_DL":
      return BatchDownload(controller, params);
    case "SAVE_APPOINTMENT":
      return SaveAppointment(controller, params);
    case "PACKAGE_APPOINTMENT":
      return PackageAppointment(controller, params);
    case "OPEN_CHAT_WINDOW":
      return OpenChatWindow(controller, params);
    case "CLOSE_ERROR_MODAL":
      return CloseErrorModal(controller, params);
    default:
      break;
  }
};

const OpenChatWindow: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      patientHNChatList: [...(prevState.patientHNChatList || []), params.patientHN],
    };
  });
};
const GetDivisionProfile: Handler = async (controller, params) => {
  const [res] = await OfficialAccountDivisionDetail.retrieve({
    params: {},
    extra: { division: controller.data.division || 0 },
    apiToken: controller.apiToken,
  });

  let divisionProfile = {};
  if (res) {
    divisionProfile = {
      ...res,
      account_link: res.token
        ? `${CONFIG.OFFICIAL_ACCOUNT_HOST || "https://ishealth.app"}/OA/${
            res.id
          }/?openExternalBrowser=1`
        : "",
      division_address: {
        city: res.city?.id,
        district: res.district?.id,
        province: res.province?.id,
        full_address_text: res.address_text,
        zipcode: res.city?.zipcode,
        place_id: res.place_id,
        latitude: res.latitude,
        longitude: res.longitude,
      },
      division_name: res.division_name,
      hospital_name: res.hospital_name,
      image_file: res.image_file,
      address_text: res.address_text,
      full_address_text: res.full_address_text,
      tax_id: res?.tax_id,
    };
  }

  return divisionProfile;
};

export const CloseErrorModal: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      MakeAppointmentMeHeySequence: {
        ...prevState.MakeAppointmentMeHeySequence,
        showError: false,
        errorMessage: null,
      },
    };
  });
};

export const SaveAppointment: Handler = async (controller, params) => {
  let state = controller.getState();
  let divisionProfile: any = null;
  let inject = false;
  if (!state?.MakeAppointmentMeHeySequence.divisionProfile) {
    divisionProfile = await GetDivisionProfile(controller, params);
    inject = true;
  } else {
    divisionProfile = state?.MakeAppointmentMeHeySequence.divisionProfile;
  }

  console.log("CreateAppointment params: ", params);
  let officialAccount = {
    full_address_text: divisionProfile.full_address_text,
    name: divisionProfile.name,
    division_name: divisionProfile.division_name,
    image_file: divisionProfile.image_file,
    id: divisionProfile.id,
    division: divisionProfile.division,
  };

  const estimateAtISO = formatDateTimeToISO(
    params?.appointmentData?.date,
    params?.appointmentData?.appointmentTime,
  );
  console.log("estimateAtISO: ", estimateAtISO);
  console.log("officialAccount: ", officialAccount);

  let r = null;
  let e = null;
  let n = null;

  if (params?.appointmentData?.appointmentId) {
    [r, e, n] = await PatientAppointmentUpdate.update({
      pk: params?.appointmentData?.appointmentId,
      extra: {
        division: controller.data.division,
      },
      data: {
        division: controller.data.division,
        patient: params?.appointmentData?.patientID,
        order_note: params?.appointmentData?.details || "",
        estimated_at_iso: estimateAtISO,
        ...(params?.dsb?.doctor_dsb_id && {
          division_service_block: params.dsb.doctor_dsb_id,
          estimated_duration: params.dsb.estimated_duration,
        }),
      },
      apiToken: controller.apiToken,
    });
  } else {
    [r, e, n] = await PatientAppointmentView.create({
      extra: {
        division: controller.data.division,
      },
      data: {
        division: controller.data.division,
        patient: params?.appointmentData?.patientID,
        division_service_block: params?.dsb?.doctor_dsb_id,
        order_note: params?.appointmentData?.details || "",
        estimated_at_iso: estimateAtISO,
        estimated_duration: params?.dsb?.estimated_duration,
        repetition_note: "",
        send_message: true,
        extra: {
          service_location_type: "division",
          official_account: officialAccount,
        },
      },
      apiToken: controller.apiToken,
    });
  }

  console.log("e:", e);

  // Update Wallet Credit
  controller.handleEvent({ message: "HandleGetCreditWalletLatest", params: {} } as any);

  controller.setState(
    (prevState) => {
      return {
        MakeAppointmentMeHeySequence: {
          ...prevState.MakeAppointmentMeHeySequence,
          ...(inject && divisionProfile && { divisionProfile: divisionProfile }),
          ...(r && !e && { showSuccess: true, selectedAppointmentDetail: r }),
          ...(e && {
            showError: true,
            errorMessage: e?.["__all__"]?.join(",") || "ไม่สามารถเพิ่มรายการนัดหมายได้",
          }),
        },
      };
    },
    async () => {
      // Reload calendar again
      await BatchDownload(controller, {
        currentDate: controller.getState().MakeAppointmentMeHeySequence.currentDate,
      });
      if (!e && r) {
        setTimeout(() => {
          controller.setState((prevState) => {
            return {
              MakeAppointmentMeHeySequence: {
                ...prevState.MakeAppointmentMeHeySequence,
                ...(!e && r && { showSuccess: false }),
                // ...(!r && { showError: false , errorMessage: null}),
              },
            };
          });
        }, 50000);
      }
    },
  );
};

export type PackageAppointmentResult = {
  status: "success" | "invalid" | "unavailable" | "failed" | "uncertain" | "partial";
  appointmentId?: number;
};

// The scheduling API can return either a list or a paginated response.
const getFreshPackageSchedule = async (controller: any, date: string, doctorDsbId: number) => {
  let page = 1;
  let found: any = null;
  do {
    const [response, error] = await Scheduling.get({
      command: "DivisionServiceBlockFilter",
      apiToken: controller.apiToken,
      extra: { division: controller.data.division },
      params: {
        divisions: controller.data.division,
        start_date: date,
        end_date: date,
        pagination_class: "page_number",
        page,
      },
    });
    if (error || !response) return null;
    const blocks = Array.isArray(response) ? response : response.items;
    if (!Array.isArray(blocks)) return null;
    for (const block of blocks) {
      for (const provider of block.providers || []) {
        const dsb = provider.dsb;
        if (dsb?.doctor_dsb_id === doctorDsbId && dsb.date === date) {
          if (found) return null;
          found = dsb;
        }
      }
    }
    if (Array.isArray(response) || !response.next) return found;
    page++;
  } while (page <= 100);
  return null;
};

export const PackageAppointment: Handler = async (controller, params) => {
  const report = (result: PackageAppointmentResult) => {
    params.onResult?.(result);
    if (!params.onResult && result.status !== "success") {
      controller.setState((prevState) => ({
        MakeAppointmentMeHeySequence: {
          ...prevState.MakeAppointmentMeHeySequence,
          showError: true,
          errorMessage: result.status === "invalid"
            ? "กรุณาเลือกรายการนัดหมาย"
            : "ไม่สามารถบันทึกนัดหมายได้ กรุณาตรวจสอบข้อมูล",
        },
      }));
    }
    return result;
  };
  const checked = Array.isArray(params.checkedProductIds) ? params.checkedProductIds : [];
  const packageItems = getValidPackageSelection(Array.isArray(params.items) ? params.items : [], checked);
  const dsb = params.dsb;
  const form = params.appointmentData;
  if (
    packageItems.length === 0 || packageItems.length !== new Set(checked).size ||
    !form?.patientID || !form?.date || !form?.appointmentTime ||
    !dsb?.doctor_dsb_id || !dsb?.doctor_provider_id || !dsb?.doctor_provider_name || !dsb?.date ||
    !params.package || !controller.data.division
  ) return report({ status: "invalid" });

  const [day, month, year] = String(form.date).split("/");
  if (`${year}-${month}-${day}` !== dsb.date || !isAppointmentTimeAvailable(dsb, form.appointmentTime)) {
    return report({ status: "invalid" });
  }

  let freshDsb: any;
  try {
    freshDsb = await getFreshPackageSchedule(controller, dsb.date, dsb.doctor_dsb_id);
  } catch {
    return report({ status: "unavailable" });
  }
  if (
    !freshDsb || freshDsb.doctor_provider_id !== dsb.doctor_provider_id ||
    freshDsb.doctor_provider_name !== dsb.doctor_provider_name ||
    freshDsb.doctor_start_time !== dsb.doctor_start_time ||
    freshDsb.doctor_end_time !== dsb.doctor_end_time ||
    freshDsb.doctor_dsb_slot_length !== dsb.doctor_dsb_slot_length ||
    !isAppointmentTimeAvailable(freshDsb, form.appointmentTime) ||
    (params.isCurrent && !params.isCurrent())
  ) return report({ status: "unavailable" });

  let estimateAtISO: string | undefined;
  try {
    estimateAtISO = formatDateTimeToISO(form.date, form.appointmentTime);
  } catch {
    return report({ status: "invalid" });
  }
  if (!estimateAtISO) return report({ status: "invalid" });

  let result: any;
  try {
    const [created, error] = await AppointmentPackageList.create({
      apiToken: controller.apiToken,
      data: {
        patient: form.patientID,
        dsb_id: dsb.doctor_dsb_id,
        doctor_note: "",
        items: packageItems,
        estimated_at: estimateAtISO,
      } as any,
      extra: { division: controller.data.division },
    });
    if (error || !created?.id) {
      const status = error?.error?.response?.status;
      const definiteFailure = typeof status === "number" && status >= 400 && status < 500 && status !== 408;
      return report({ status: definiteFailure ? "failed" : "uncertain" });
    }
    result = created;
  } catch {
    return report({ status: "uncertain" });
  }
  if (!result.order_division) return report({ status: "partial", appointmentId: result.id });

  // Once created, no later failure may cause the appointment to be created again.
  try {
    const [patientApp, listError] = await PatientAppointmentView.list({
      apiToken: controller.apiToken,
      params: { patient_id: form.patientID, division_id: result.order_division, exclude_cancel: true },
    });
    if (listError || !Array.isArray(patientApp?.items)) {
      return report({ status: "partial", appointmentId: result.id });
    }
    const appointment = patientApp.items.find((item: any) => item.content_id === result.id);
    if (!appointment?.id) return report({ status: "partial", appointmentId: result.id });

    const state = controller.getState();
    const profile = state?.MakeAppointmentMeHeySequence.divisionProfile || await GetDivisionProfile(controller, params);
    if (!profile?.id || !profile?.division) return report({ status: "partial", appointmentId: result.id });

    const [updated, updateError] = await PatientAppointmentUpdate.update({
      apiToken: controller.apiToken,
      data: {
        division: result.order_division,
        patient: form.patientID,
        extra: {
          service_location_type: "division",
          official_account: {
            full_address_text: profile.full_address_text,
            name: profile.name,
            division_name: profile.division_name,
            image_file: profile.image_file,
            id: profile.id,
            division: profile.division,
            address_text: profile.address_text,
          },
          package_orders: [{
            id: params.package.id,
            package_type: params.package.package_type,
            package_type_name: params.package.package_type_name,
            product: params.package.product,
            product_name: params.package.product_name,
          }],
        },
      } as any,
      pk: appointment.id,
    });
    if (updateError || !updated) return report({ status: "partial", appointmentId: result.id });
  } catch {
    return report({ status: "partial", appointmentId: result.id });
  }

  report({ status: "success", appointmentId: result.id });
  params.onSuccess?.();
  return { status: "success", appointmentId: result.id };
};

const sortDSB = (dsb: any) => {
  let sorted = dsb.map((item: any) => {
    return {
      ...item,
      providers: (item.providers || []).sort(
        (a: any, b: any) => a.doctor_provider_id - b.doctor_provider_id,
      ),
    };
  });
  return sorted;
};

export const BatchDownload: Handler = async (controller, params) => {
  const division = controller.data.division;
  // console.log("BatchDownload: ", controller.getState().MakeAppointmentMeHeySequence.currentDate);
  // Get Entire year

  controller.setState((prevState) => {
    return {
      MakeAppointmentMeHeySequence: {
        ...prevState.MakeAppointmentMeHeySequence,
        AppointmentLoading: prevState.MakeAppointmentMeHeySequence.dsbMonthStore,
      },
    };
  });

  let dsbProviderFilterResult: any = null;
  let { start, end } = getDSBRangeExtended(params.currentDate);

  let [res] = await Scheduling.get({
    command: "DivisionServiceBlockFilter",
    apiToken: controller.apiToken,
    extra: {
      division: controller.data.division,
    },
    params: {
      divisions: controller.data.division,
      start_date: start,
      end_date: end,
    },
  });

  if (controller.data.division !== division) return;
  if (res) {
    dsbProviderFilterResult = res;
    // dsbProviderFilterResult = res.reduce(
    //   (
    //     acc: Record<number, (typeof dsbProviderFilterResult)[0]>,
    //     item: (typeof dsbProviderFilterResult)[0]
    //   ) => {
    //     acc[item.dsb_id] = item;
    //     return acc;
    //   },
    //   {} as Record<number, (typeof dsbProviderFilterResult)[0]>
    // );

    // Merge DSB data by dsb_id (update existing, append new)
    controller.setState((prevState) => {
      // Create a map of existing DSB items by dsb_id
      console.log(
        "prevState.MakeAppointmentMeHeySequence.dsb: ",
        prevState.MakeAppointmentMeHeySequence?.dsb,
      );
      let currentDSB = prevState.MakeAppointmentMeHeySequence?.dsb;

      if (currentDSB) {
        const dsbMap = new Map(currentDSB.map((item: any) => [item.dsb_id, item]));

        // Update existing or add new items from the result
        dsbProviderFilterResult.forEach((item: any) => {
          dsbMap.set(item.dsb_id, item);
        });

        // Convert map back to array
        let mergedDsb = Array.from(dsbMap.values());

        mergedDsb = sortDSB(mergedDsb);

        return {
          MakeAppointmentMeHeySequence: {
            ...prevState.MakeAppointmentMeHeySequence,
            dsb: mergedDsb,
            AppointmentLoading: false,
          },
        };
      } else {
        return {};
      }
    });
  } else {
    controller.setState((prevState) => {
      return {
        MakeAppointmentMeHeySequence: {
          ...prevState.MakeAppointmentMeHeySequence,
          AppointmentLoading: false,
        },
      };
    });
  }
};

export const SetProviderFilters: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      MakeAppointmentMeHeySequence: {
        ...prevState.MakeAppointmentMeHeySequence,
        selectedProviderIdsList: params.selectedProviderIdsList,
      },
    };
  });
};

export const SetCurrentDate: Handler = async (controller, params) => {
  const state = controller.getState();
  const oldDate = state.MakeAppointmentMeHeySequence.currentDate;
  const newDate = params.currentDate;

  // Check if month has changed (either + or -)
  const oldMonth = oldDate.getMonth();
  const oldYear = oldDate.getFullYear();
  const newMonth = newDate.getMonth();
  const newYear = newDate.getFullYear();

  const monthCrossed = oldMonth !== newMonth || oldYear !== newYear;

  if (monthCrossed) {
    // Download data for new month before setting date
    BatchDownload(controller, { currentDate: newDate });
  }

  controller.setState((prevState) => {
    return {
      MakeAppointmentMeHeySequence: {
        ...prevState.MakeAppointmentMeHeySequence,
        currentDate: params.currentDate,
      },
    };
  });
};

export const SetViewType: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      MakeAppointmentMeHeySequence: {
        ...prevState.MakeAppointmentMeHeySequence,
        viewType: params.viewType,
      },
    };
  });
};

export const SetShowEditModal: Handler = async (controller, params) => {
  const [pa] = await PatientAppointmentUpdate.retrieve({
    pk: params.appointmentId,
    extra: {
      division: controller.data.division,
    },
    apiToken: controller.apiToken,
  });

  controller.setState((prevState) => {
    return {
      MakeAppointmentMeHeySequence: {
        ...prevState.MakeAppointmentMeHeySequence,
        showCreateModal: params.showCreateModal,
        selectedAppointmentDetail: pa ? pa : null,
      },
    };
  });
};

export const SetShowCreateModal: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      MakeAppointmentMeHeySequence: {
        ...prevState.MakeAppointmentMeHeySequence,
        showCreateModal: params.showCreateModal,
        selectedAppointmentDetail: null,
        showSuccess: false,
      },
    };
  });
};

const getDSBRange = (currentDate: Date) => {
  // const date = new Date(currentDate);

  const formatYearMonth = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

  // Get previous month (1st day)
  const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
  // console.log("getDSBRange prevMonth: ", prevMonth);

  // Get next month (last day)
  const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0);
  // console.log("getDSBRange nextMonth: ", nextMonth);

  // Format to YYYY-MM-DD
  const start = formatDateAD(prevMonth);
  const end = formatDateAD(nextMonth);
  // console.log("getDSBRange start: ", start);
  // console.log("getDSBRange end: ", end);

  const store = [
    formatYearMonth(prevMonth),
    formatYearMonth(currentDate),
    formatYearMonth(nextMonth),
  ];

  return { start, end, store: new Set<string>(store) };
};

const getDSBRangeExtended = (currentDate: Date) => {
  const formatYearMonth = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

  // Get previous month (1st day)
  const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);

  // Get next month (last day)
  const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0);

  const start = formatDateAD(prevMonth);
  // console.log('getDSBRangeExtended start: ', start);
  const end = formatDateAD(nextMonth);
  // console.log('getDSBRangeExtended end: ', end);

  // Generate 3 months: previous, current, next
  const store = [
    formatYearMonth(prevMonth),
    formatYearMonth(currentDate),
    formatYearMonth(nextMonth),
  ];

  return { start, end, store: new Set<string>(store) };
};
